import { Dictionary } from 'lodash';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { updateUserSettings } from './slice';

export const useUpdateUserSettings = () => {
  const dispatch = useDispatch();

  return useCallback(
    (partialUserSettings: Dictionary<object>) => {
      dispatch(updateUserSettings(partialUserSettings));
    },
    [dispatch],
  );
};
